import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PreviewHeaderComponent } from 'components/queue-view/queue-view-tab/work-item-preview/preview-header/preview-header.component';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { AvatarModule } from 'shared/components/avatar/avatar.module';
import { WorkItemPreviewLaneButtonsModule } from 'components/queue-view/queue-view-tab/work-item-preview/preview-lane-buttons/work-item-preview-lane-buttons.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule,
    AvatarModule,
    WorkItemPreviewLaneButtonsModule
  ],
  declarations: [
    PreviewHeaderComponent
  ],
  exports: [
    PreviewHeaderComponent
  ]
})
export class PreviewHeaderModule {}
